/* eslint-disable no-alert */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';
import PropTypes from 'prop-types';
import CopyToClipboard from 'react-copy-to-clipboard';
import ResetButton from 'Components/resetBtn';
import Modal from 'react-modal';
import track, { TrackingPropType } from 'react-tracking';
import share from 'Services/share';
import shareConfig from 'Config/shareConfig';
import * as iconStyles from '../../styles/icons.css';
import * as buttonStyles from '../../styles/buttons.css';
import * as styles from './tableToolbar.css';

class TableToolbar extends Component {
  constructor() {
    super();
    this.state = {
      modalVisible: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.trackShareEvent = this.trackShareEvent.bind(this);
  }

  toggleModal() {
    this.setState((prevState) => ({ modalVisible: !prevState.modalVisible }));
  }

  trackShareEvent(event) {
    this.props.tracking.trackEvent({
      event: 'csrShareEvent',
      csrShareType: event,
    });
  }

  render() {
    const {
      bottom,
      onDownload,
      addIndicator,
      addState,
      shortenedUrl,
    } = this.props;
    const toolbarClass = `${styles.toolsWrapper} csr-share`;
    return (
      <div>
        {!!bottom && (
          <div className={styles.addWrapper}>
            <button
              onClick={addIndicator}
              className={buttonStyles.buttonSolid}
            >
              <i className={iconStyles.iconPlus} />
              <span>Add/Modify Indicators</span>
            </button>
            <button
              onClick={addState}
              className={buttonStyles.buttonSolid}
            >
              <i className={iconStyles.iconPlus} />
              <span>Add/Modify States</span>
            </button>
          </div>
        )}
        <div className={styles.toolbar}>
          <ResetButton />
          <div className={toolbarClass}>
            <span className={styles.label}>Tools:</span>
            <button
              className={`${buttonStyles.buttonTransparent} csr-download`}
              onClick={() => {
                this.trackShareEvent('download');
                onDownload();
              }}
            >
              <div className={buttonStyles.iconContainer}>
                <i className={iconStyles.iconDownload} />
                <span>Download Data</span>
              </div>
            </button>
            <a
              className={`${buttonStyles.buttonTransparent} csr-email`}
              href={share('email', window.location.href, shareConfig.title)}
              onClick={() => { this.trackShareEvent('email'); }}
            >
              <div className={buttonStyles.iconContainer}>
                <i className={iconStyles.iconEmail} />
                <span>Email</span>
              </div>
            </a>
            <CopyToClipboard
              text={window.location.href}
              onCopy={() => {
                this.trackShareEvent('copy');
                alert('URL copied to clipboard');
              }}
            >
              <button className={`${buttonStyles.buttonTransparent} csr-copy`}>
                <div className={buttonStyles.iconContainer}>
                  <i className={iconStyles.iconCopy} />
                  <span>Copy Link</span>
                </div>
              </button>
            </CopyToClipboard>
            <button
              className={`${buttonStyles.buttonTransparent} csr-share`}
              onClick={this.toggleModal}
            >
              <div className={buttonStyles.iconContainer}>
                <i className={iconStyles.iconShare} />
                <span>Share</span>
              </div>
            </button>
            <Modal
              style={{
                overlay: {
                  zIndex: 9,
                },
                content: {
                  height: '48px',
                  left: 'calc(50% - 24px)',
                  padding: '5px',
                  top: 'calc(40% - 69px)',
                  width: '138px',
                },
              }}
              isOpen={this.state.modalVisible}
              onRequestClose={this.toggleModal}
              contentLabel={'Sharing'}
            >
              <div className={styles.shareWrapper}>
                <a
                  href={share('facebook', shortenedUrl)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${buttonStyles.social} csr-facebook`}
                  onClick={() => { this.trackShareEvent('facebook'); }}
                ><i className={iconStyles.iconFacebook} /></a>
                <a
                  href={share(
                    'twitter',
                    shortenedUrl,
                    shareConfig.text,
                    shareConfig.twitter.via,
                    shareConfig.twitter.hashtags
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${buttonStyles.social} csr-twitter`}
                  onClick={() => { this.trackShareEvent('twitter'); }}
                ><i className={iconStyles.iconTwitter} /></a>
                <a
                  href={share(
                    'linkedin',
                    shortenedUrl,
                    shareConfig.title,
                    shareConfig.summary,
                    shareConfig.source
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${buttonStyles.social} csr-linkedin`}
                  onClick={() => { this.trackShareEvent('linkedin'); }}
                ><i className={iconStyles.iconLinkedin} /></a>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

TableToolbar.defaultProps = {
  bottom: false,
  tracking: { trackEvent: () => {} },
};

TableToolbar.propTypes = {
  bottom: PropTypes.bool,
  onDownload: PropTypes.func.isRequired,
  addIndicator: PropTypes.func.isRequired,
  addState: PropTypes.func.isRequired,
  tracking: TrackingPropType,
  shortenedUrl: PropTypes.string.isRequired,
};

// Push to SHF 2.0
const updateUrl = (stage) => {
  // Get indicators from url.
  const {
    i: indicator = '',
    '?i': indicatorQS = '', // If the first item.
  } = qs.parse(location.search);
  const indicators = indicator || indicatorQS;

  // Get regions from url.
  const {
    g: region = '',
    '?g': regionQS = '', // If the first item.
  } = qs.parse(location.search);
  const regions = region || regionQS;

  // Split and form params.
  const selectedIndicators = indicators ? indicators.split('~').join(',') : '';
  const selectedRegions = regions ? regions.toUpperCase().split('~').join(',') : '';
  const params = {
    indicators: selectedIndicators,
    regions: selectedRegions,
    stage,
  };
  window.location.href = `/statedata/custom/?${qs.stringify(params)}`;
};

const mapDispatchToProps = () => ({
  addIndicator: () => updateUrl(1),
  addState: () => updateUrl(2),
});

export default connect(
  (store) => ({ store, shortenedUrl: store.bitly.shortened }),
  mapDispatchToProps
)(track()(TableToolbar));



// WEBPACK FOOTER //
// ./app/components/tableToolbar/index.js